export default __webpack_public_path__ + "static/media/acorn-50.0391d5a0.png";